import styled from 'styled-components';

/* brand tokens */
const P = '#9cc54b';   /* primary */
const PD = '#7aaa2e';   /* primary dark */
const PL = '#b8d97a';   /* primary light */
const PBG = '#f3f9e8';  /* primary tint bg */

const DelipointManagementStyle = styled.div`

    /* ── loading ──────────────────────────────────────────────────────────── */

    .dp-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
  }

    /* ── hero balance card ────────────────────────────────────────────────── */

    .dp-hero {
        position: relative;
    display: flex;
        align-items: stretch;
        justify-content: space-between;
    flex-wrap: wrap;
        gap: 0;
        background: linear-gradient(135deg, ${PD} 0%, ${P} 100%);
        border-radius: 20px;
        padding: 0;
        margin-bottom: 28px;
        color: #fff;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(156, 197, 75, 0.35);
    }

    /* subtle pattern overlay */

    .dp-hero::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
        radial-gradient(circle at 10% 90%, rgba(0, 0, 0, 0.08) 0%, transparent 40%);
        pointer-events: none;
    }

    .dp-hero-left {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 28px 32px;
        flex: 1;
        min-width: 200px;
    }

    .dp-hero-label {
        font-size: 0.72rem;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        opacity: 0.85;
        font-weight: 500;
    }

    .dp-hero-balance {
        display: flex;
        align-items: baseline;
        gap: 6px;
        line-height: 1;
    }

    .dp-hero-number {
        font-size: 3.2rem;
        font-weight: 800;
        line-height: 1;
        letter-spacing: -1px;
    }

    .dp-hero-unit {
        font-size: 1rem;
        opacity: 0.8;
        font-weight: 500;
        letter-spacing: 0.3px;
    }

    .dp-tier-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(255, 255, 255, 0.22);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 20px;
        padding: 5px 12px 5px 6px;
        width: fit-content;
        backdrop-filter: blur(4px);
    }

    .dp-tier-none {
        opacity: 0.75;
    }

    .dp-tier-img {
        width: auto;
        height: 22px;
        object-fit: contain;
        border-radius: 50%;
    }

    .dp-tier-icon {
        font-size: 17px;
        line-height: 1;
    }

    .dp-tier-name {
        font-size: 0.82rem;
        font-weight: 600;
        letter-spacing: 0.2px;
    }

    .dp-tier-multiplier {
        font-size: 0.72rem;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        padding: 1px 7px;
        font-weight: 700;
    }

    /* ── divider between hero sections ─────────────────────────────────────── */

    .dp-hero-divider {
        width: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin: 20px 0;
        flex-shrink: 0;
  }

    /* progress panel (right side of hero) */

    .dp-hero-right {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
        padding: 28px 32px;
        min-width: 200px;
        max-width: 300px;
        flex: 1;
    }

    .dp-tier-progress-label {
        font-size: 0.7rem;
        opacity: 0.8;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        font-weight: 500;
    }

    .dp-tier-progress-bar {
        width: 100%;
        height: 6px;
        background: rgba(255, 255, 255, 0.25);
        border-radius: 99px;
        overflow: hidden;
    }

    .dp-tier-progress-fill {
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 99px;
        transition: width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
    }

    .dp-tier-progress-text {
        font-size: 0.76rem;
        opacity: 0.85;
        font-weight: 500;
    }

    /* ── section ──────────────────────────────────────────────────────────── */

    .dp-section {
        margin-bottom: 28px;
    }

    .dp-section-header {
    display: flex;
    align-items: center;
        gap: 8px;
        margin-bottom: 14px;
    }

    .dp-section-dot {
        width: 4px;
        height: 18px;
        background: ${P};
        border-radius: 99px;
        flex-shrink: 0;
    }

    .dp-section-title {
        font-size: 1rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0;
    }

    /* ── empty state ──────────────────────────────────────────────────────── */

    .dp-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 52px 24px;
        background: ${PBG};
        border-radius: 14px;
        border: 1.5px dashed ${PL};
        color: #888;
        font-size: 0.88rem;
    }

    .dp-empty-icon {
        font-size: 2.2rem;
        line-height: 1;
    }

    /* ── transaction list ─────────────────────────────────────────────────── */

    .dp-tx-list {
        display: flex;
        flex-direction: column;
        border-radius: 14px;
        overflow: hidden;
        border: 1px solid #ececec;
        background: #fff;
    }

    .dp-tx-row {
        display: flex;
        align-items: stretch;
        padding: 14px 18px;
        background: #fff;
        border-left: 4px solid ${P};
        transition: background 0.12s;

        &:hover {
            background: ${PBG};
        }

        & + & {
            border-top: 1px solid #f2f2f2;
        }
    }

    .dp-tx-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
        overflow: hidden;
    }

    /* top row: title + points amount */

    .dp-tx-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }

    .dp-tx-title {
        font-size: 0.88rem;
        font-weight: 500;
        color: #444;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
    }

    .dp-tx-points {
        flex-shrink: 0;
        font-size: 1.25rem;
        font-weight: 800;
        white-space: nowrap;
        display: flex;
        align-items: baseline;
        gap: 3px;
        letter-spacing: -0.5px;
    }

    .dp-tx-pts {
        font-size: 0.7rem;
        font-weight: 600;
        opacity: 0.55;
        margin-left: 1px;
        letter-spacing: 0;
    }

    /* bottom row: badge + redeemed value + date */

    .dp-tx-bottom {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .dp-tx-badge {
        flex-shrink: 0;
        font-size: 0.66rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 2px 8px;
        border-radius: 20px;
        white-space: nowrap;
    }

    .dp-tx-redeemed {
        font-size: 0.72rem;
        color: #888;
        font-weight: 500;
    }

    .dp-tx-date {
        font-size: 0.72rem;
        color: #c0c0c0;
        font-weight: 400;
        margin-left: auto;
    }

    /* ── load more ────────────────────────────────────────────────────────── */

    .dp-load-more {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .dp-load-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 32px;
        border-radius: 99px;
        border: 2px solid ${P};
        background: transparent;
        color: ${PD};
        font-size: 0.88rem;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        letter-spacing: 0.2px;

        &:hover:not(:disabled) {
            background: ${P};
            color: #fff;
            box-shadow: 0 4px 14px rgba(156, 197, 75, 0.4);
            transform: translateY(-1px);
        }

        &:active:not(:disabled) {
            transform: translateY(0);
        }

        &:disabled {
            opacity: 0.55;
            cursor: default;
    }
  }
`;

export default DelipointManagementStyle;
